import logo from './logo.svg';
import './App.css';
import { useEffect, useState } from 'react';
import pill from './assets/pill.png'
import { getBlogs } from './api/strapi'
import { Link } from 'react-router';

function App() {
  const [blogs, setBlogs] = useState([])

  useEffect(() => {
    getBlogs().then(data => {
      console.log(data)
      setBlogs(data)
    }).catch(_ => {
      setBlogs([])
    })

  }, []
)

  return (
    <div className="App relative">
      <section className={"curve h-48 overflow-x-hidde whitespace-nowrap absolute w-screen animate-rightway"}>
        <div className={"showing gridpattern inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
        <div className={"increase inline-block"}></div>
        <div className={"peak inline-block"}></div>
        <div className={"decrease inline-block"}></div>
        <div className={"valley inline-block"}></div>
      </section>
      
      <div className='lg:mx-36 mx-4 px-8 pt-36 text-4xl h-screen bg-black bg-opacity-40 text-white'>
        <p className='stretched-text text-9xl'>WINTERS...</p>
        <div className='grid grid-cols-10 gap-4'>
          <div className='lg:row-span-4 row-span-full col-span-4'>
            <p className='border-4 border-dashed p-2 rounded-md'>
              <p className=' font-bold'>About me</p>
              That creature that organises in Nijmegen sometimes if they feel like it. roams your hallways and can sometimes be found on line. The worlds most reliable narrator.
              </p>
          </div>
          {/* <div class="col-span-2">
            




            
          </div> */}
          <div class="lg:row-span-2 row-span-full col-span-6">
            <p className='font-bold'>Blog</p>
            {
              blogs.map((b, i) => {
                return (
                  <Link to={'/blog/' + b.documentId} className='cursor-pointer inline-block w-full'>🔗 {b.title}</Link>
                )
              })
            }
          </div>
        </div>
        
      </div>

      
     
    </div>
  );
}

export default App;
